<ng-container [ngSwitch]="column.template||column.name">          

    <span *ngSwitchCase="'time'"
        class="text-nowrap">
        {{record[column.name]|date:'yyyy-MM-dd':'UTC'}}
    </span>

    <ng-container *ngSwitchDefault>
        {{record[column.name]}}
    </ng-container>

</ng-container>

